import { render, staticRenderFns } from "./ListEvents.vue?vue&type=template&id=785134de&"
import script from "./ListEvents.vue?vue&type=script&lang=js&"
export * from "./ListEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports